import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const FuncaoDinamicaList = props => <DefaultDataTable data={props} />;
